import { createOrderRequest, type OrderDetailResponse } from '@forbiz/contracts'

import { buildOrderBody, orderToForm, type FormState } from './orderForm.js'
import { ordersApi } from './orders.js'

/**
 * 재주문 / 복제 (BIZ-80).
 *
 * 기존 주문에서 **상품·발신자·문구**는 그대로 잇고, **수령정보(고인명·빈소·배송지·희망일 등)**는
 * 비운 새 임시저장을 만든다. 그리고 주문흐름(/orders/:id/edit 프리필)으로 진입해 사용자가
 * 받는 곳만 새로 채우게 한다. 새 API 없이 기존 create(초안) + 편집 프리필을 재사용한다.
 */

/** 수령·배송·일정 필드를 비운다. 상품·발신자·문구·행사종류는 유지. */
function clearRecipient(form: FormState): FormState {
  return {
    ...form,
    deliveryAddress: '', deliveryAddressDetail: '', deliveryZipcode: '', deliveryPlaceName: '',
    desiredDate: '', desiredTimeSlot: '', deliveryNote: '', recipientPhone: '', partnerName: '',
    mortuaryRoom: '', deceasedName: '', mournerName: '',
    eventName: '', eventTarget: '',
    recipientName: '', recipientOrg: '', recipientDept: '', recipientTitle: '',
    companyMemo: '',
  }
}

/** 주문 상세(본문 포함)에서 재주문 초안을 만들고 새 주문 id를 돌려준다. */
export async function createReorderDraft(companyId: number, order: OrderDetailResponse): Promise<number> {
  if (!order.item) throw new Error('상품 정보가 없어 다시 주문할 수 없습니다')
  const body = buildOrderBody(order.occasionType, order.item.productId, clearRecipient(orderToForm(order)), false)
  const parsed = createOrderRequest.safeParse(body)
  if (!parsed.success) throw new Error('재주문 초안을 만들지 못했습니다')
  const res = await ordersApi.create(companyId, parsed.data)
  return res.order.id
}

/** 목록 항목(요약만 있음)에서 재주문 — 상세를 먼저 불러 본문을 채운다. */
export async function createReorderDraftFromId(companyId: number, orderId: number): Promise<number> {
  const { order } = await ordersApi.detail(orderId)
  return createReorderDraft(companyId, order)
}
